<template>
  <div class="sidebar-pinned">
    <Navbar/>

    <main class="admin-main">
    <!--site header begins-->

   <section class="admin-content">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-user" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">{{ user.firstname }} {{ user.lastname }}</h4>
              <small style="opacity: .8;">TPA employee dashboard</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Summary Stat Cards ── -->
        <div class="row mb-1">
          <div class="col-lg-6 col-md-6">
            <router-link :to="{ path: '/view-clients-tpa'}" class="text-decoration-none">
              <div class="stat-card">
                <div class="stat-icon-wrap" style="background: #e8f4ff;">
                  <i class="fe fe-users" style="color: #2563eb;"></i>
                </div>
                <div>
                  <p class="stat-label">OHIS</p>
                  <h3 class="stat-value">Osogbo, Osun</h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-6 col-md-6">
            <router-link :to="{ path: '/view-clients-tpa'}" class="text-decoration-none">
              <div class="stat-card">
                <div class="stat-icon-wrap" style="background: #ecfdf5;">
                  <i class="fe fe-users" style="color: #059669;"></i>
                </div>
                <div>
                  <p class="stat-label">Enrolled Users</p>
                  <h3 class="stat-value">{{ clients.total }}</h3>
                </div>
              </div>
            </router-link>
          </div>

        </div>

        <div class="row">
          <div class="col-md-12 mb-4">
            <div class="card table-card shadow">
              <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">
                    <i class="fe fe-users text-primary mr-2"></i> Enrollees
                  </h6>
                  <small class="text-muted">{{ clients.total }} record(s)</small>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th px-4">Name</th>
                      <th class="table-th">Phone Number</th>
                      <th class="table-th">Sector</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in clients.data" v-bind:key="client.id" class="table-row">
                      <td class="px-4 py-3">
                        <div class="d-flex align-items-center" style="gap: 10px;">
                          <div class="avatar avatar-sm" v-if="client.user_image != null">
                            <img :src="`https://claimify-api.hayokmedicare.ng/image/${client.user_image}`"
                              class="avatar-img avatar-sm rounded-circle" alt="">
                          </div>
                          <div class="employee-avatar" v-else>
                            {{ (client.firstname || '?')[0].toUpperCase() }}
                          </div>
                          <p class="mb-0 font-weight-bold" style="font-size: .88rem;">
                            {{ client.firstname }} {{ client.lastname }}
                          </p>
                        </div>
                      </td>
                      <td class="py-3" style="font-size: .88rem;">{{ client.phone_number }}</td>
                      <td class="py-3"><span class="rel-chip">{{ client.sector }}</span></td>
                      <td class="py-3">
                        <router-link :to="{ path: '/client/' + client.id}">
                          <button type="button" class="btn btn-sm btn-outline-primary">
                            <i class="fe fe-eye mr-1"></i> View
                          </button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>

      </div>
        <Footer/>
    </section>
</main>


    </div>

</template>

<script>
import Navbar from '@/views/Navbar.vue'
import Footer from '@/views/Footer.vue'

export default {
  components: {
     Navbar, Footer
  },
  
  data(){
    return{
      auth_user:"",
      OfficerDetails:"",
      clients:"",
      appointments:"",
      providers:"",
      user:null,

    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/OfficerDetails/${this.user.id}`)
                .then(response => {
                    this.OfficerDetails = response.data.data
                    this.clients = response.data.enrollees
                    // let officer = response.data
                    console.log(response)
                    
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{
    //
  },
  created(){
  

  }
}
</script>
<style lang="css" scoped>
  .spacer-top{
    margin-top:10px;
  }

/* Stat cards */
.stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.stat-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.stat-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 2px;
  font-weight: 600;
}

.stat-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0;
  line-height: 1.2;
}
</style>
